<template>
  <div class="d-flex flex-column overflow-x">
    <div
      v-for="(region, index) in filtre.regionsAgrial"
      :key="index"
    >
      <v-chip
        v-if="filtre.regionsAgrial.length > 1"
        color="white primary--text"
        class="pa-5 border-chip ma-1"
      >
        <div class="texte primary--text">
          {{ region.libelle }}
        </div>
        <v-icon

          right
          @click.stop="updateFiltre('regionsAgrial', region)"
        >
          mdi-close
        </v-icon>
      </v-chip>
      <v-tooltip
        v-else
        right
      >
        <template v-slot:activator="{ on, attrs, value }">
          <v-chip
            color="white primary--text"
            class="pa-5 border-chip ma-1"
            v-on="on"
          >
            <div class="texte primary--text">
              {{ region.libelle }}
            </div>
            <v-icon
              right
              disabled
            >
              mdi-cancel
            </v-icon>
          </v-chip>
        </template>
        <span>Au moins une région doit être sélectionnée</span>
      </v-tooltip>
    </div>
    <div>
      <v-chip
        v-if="filtre.typeExploitation && filtre.typeExploitation.code !== 'TOUS'"
        color="white primary--text"
        class="pa-5 border-chip ma-1"
      >
        <div class="texte primary--text">
          {{ filtre.typeExploitation.libelle }}
        </div>
        <v-icon
          right
          @click.stop="updateFiltre('typeExploitation', 'TOUS')"
        >
          mdi-close
        </v-icon>
      </v-chip>
    </div>
    <div>
      <v-chip
        v-if="filtre.typeProduction && filtre.typeProduction.code !== 'TOUS'"
        color="white primary--text"
        class="pa-5 border-chip ma-1"
      >
        <div class="texte primary--text">
          {{ filtre.typeProduction.libelle }}
        </div>
        <v-icon
          right
          @click.stop="updateFiltre('typeProduction', 'TOUS')"
        >
          mdi-close
        </v-icon>
      </v-chip>
    </div>
    <div>
      <v-chip
        v-if="filtre.potentielSol && filtre.potentielSol.code !== 'TOUS'"
        color="white primary--text"
        class="pa-5 border-chip ma-1"
      >
        <div class="texte primary--text">
          {{ filtre.potentielSol.libelle }}
        </div>
        <v-icon
          right
          @click.stop="updateFiltre('potentielSol', 'TOUS')"
        >
          mdi-close
        </v-icon>
      </v-chip>
    </div>
    <div>
      <v-chip
        v-if="filtre.ressourceEffluents && filtre.ressourceEffluents.code !== 'TOUS'"
        color="white primary--text"
        class="pa-5 border-chip ma-1"
      >
        <div class="texte primary--text">
          {{ filtre.ressourceEffluents.libelle }}
        </div>
        <v-icon
          right
          @click.stop="updateFiltre('ressourceEffluents', 'TOUS')"
        >
          mdi-close
        </v-icon>
      </v-chip>
    </div>
    <div>
      <v-chip
        v-if="filtre.stockeur && filtre.stockeur.code !== 'TOUS'"
        color="white primary--text"
        class="pa-5 border-chip ma-1"
      >
        <div class="texte primary--text">
          {{ filtre.stockeur.libelle }}
        </div>
        <v-icon
          right
          @click.stop="updateFiltre('stockeur', 'TOUS')"
        >
          mdi-close
        </v-icon>
      </v-chip>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FiltreComparaisonChips',
  props: {
    filtre: {
      type: Object,
      default: null
    }
  },
  methods: {
    updateFiltre (label, value) {
      this.$emit('updateFiltre', {label, value})
    }
  }
}
</script>
<style lang="scss" scoped>
.border-chip {
  border-radius: 20px !important;
  border: 1px solid var(--gris-clair) !important;
}

.overflow-x {
  overflow-x: auto;
}
</style>